
export const validateUrl = (inputUrl: string): [boolean, string] => {
  let urlToCheck = inputUrl.trim();
  
  if (!urlToCheck) {
    return [false, urlToCheck];
  }
  
  if (!urlToCheck.match(/^https?:\/\//i)) {
    urlToCheck = `https://${urlToCheck}`;
  }
  
  try {
    new URL(urlToCheck);
    return [true, urlToCheck];
  } catch {
    return [false, urlToCheck];
  }
};

export const getScoreColor = (score: number): string => {
  if (score >= 80) return "text-green-500";
  if (score >= 60) return "text-yellow-500";
  return "text-red-500";
};

export const getStatusIcon = (status: string) => {
  switch (status) {
    case "good":
      return "checkCircle";
    case "warning":
      return "alertCircle";
    case "bad":
      return "xCircle";
    default:
      return null;
  }
};
